<template>
	<div id="activity-create-tab-info">
		<div class="vx-row">
			<div class="vx-col md:w-3/7 w-full">
				<vx-card class="custom-height">
					<form class="form-content">
						<vs-row vs-w="12">
							<vs-col vs-lg="12" vs-sm="12" vs-xs="12">
								<div class="vx-row mb-4">
									<div class="vx-col w-full">
										<!-- NAME -->
										<label class="g-object--description" v-text="$t('Name')"></label>
										<vs-input
											v-model.trim="activity_local.name"
											class="w-full"
											name="item-name"
											v-validate="'required'"
										/>
										<span
											class="text-danger text-sm"
											v-show="errors.has('item-name')"
											v-text="$t('ActivityValidMessages.ItemName')"
										></span>
									</div>
								</div>
								<div class="vx-row mb-2">
									<div class="vx-col w-full">
										<!-- DESCRIPTIONN -->
										<label class="g-object--description" v-text="$t('Description')"></label>
										<vs-textarea
											v-model="activity_local.description"
											class="w-full"
											name="item-category"
											height="93px"
										/>
										<span
											class="text-danger text-sm"
											v-show="errors.has('item-category')"
											v-text="errors.first('item-category')"
										></span>
									</div>
								</div>
								<div class="vx-row mb-6">
									<div class="vx-col w-full md:w-2/2">
										<small
											class="g-object--description"
											v-text="$t('Activity.ServiceTime')"
										></small>
									</div>
									<div class="vx-col w-full md:w-2/5">
										<!-- HOUR -->
										<vs-input-number
											v-model="hours"
											class="g-label--normal"
											color="primary"
											:label="$t('Hours')"
											:min="0"
											:max="24"
										/>
									</div>
									<div class="vx-col w-full md:w-2/5">
										<!-- MINUTES -->
										<vs-input-number
											v-model="minutes"
											class="g-label--normal"
											color="primary"
											:label="$t('Minutes')"
											:min="0"
											:max="60"
										/>
									</div>
								</div>
								<div class="vx-row">
									<div class="vx-col w-full">
										<label
											class="g-object--description"
											v-text="$t('Activity.ActivateForm')"
										></label>
										<vx-input-group class="mb-base mt-1 items-center">
											<template slot="prepend">
												<vs-switch color="success" v-model="activity_local.active_form">
													<span slot="on" v-text="$t('Object.Yes')"></span>
													<span slot="off" v-text="$t('Object.Not')"></span>
												</vs-switch>
											</template>
											<v-select
												class="ml-2"
												v-model="selectedFormActivity"
												:options="formActivityOptions"
												:disabled="
													formActivityOptions.length <= 0 || !activity_local.active_form
												"
												:dir="$vs.rtl ? 'rtl' : 'ltr'"
											>
												<template v-slot:no-options="{search, searching}">
													<template v-if="searching">
														{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
													</template>
												</template>
											</v-select>
										</vx-input-group>
									</div>
								</div>
								<div class="vx-row">
									<div class="vx-col w-full">
										<label class="g-object--description" v-text="$t('OnDemand.OnDemand')"></label>
										<vx-input-group class="mb-base mt-1 items-center">
											<template slot="prepend">
												<vs-switch color="success" v-model="activeDrPoints">
													<span slot="on" v-text="$t('Object.Yes')"></span>
													<span slot="off" v-text="$t('Object.Not')"></span>
												</vs-switch>
											</template>
											<vs-input
												class="ml-2"
												type="number"
												v-model.number="activity_local.dr_points"
												min="0"
												:disabled="!activeDrPoints"
											/>
										</vx-input-group>
										<p>
											<vs-alert
												color="warning"
												:active.sync="onDemandAlert"
												closable
												icon-pack="feather"
												close-icon="icon-x"
											>
												<span>{{ $t("Activity.DRPointsRequired") }}</span>
											</vs-alert>
										</p>
									</div>
								</div>
							</vs-col>
						</vs-row>
					</form>
					<p>
						<vs-alert
							class="mt-2"
							color="warning"
							:title="$t('Activity.AlertFormNotFoundTitle')"
							:active.sync="serviformAlert"
							closable
							icon-pack="feather"
							close-icon="icon-x"
						>
							<span v-text="$t('Activity.AlertFormNotFoundText')"></span>
						</vs-alert>
					</p>
					<p>
						<vs-alert
							class="mt-4"
							color="warning"
							:title="$t('Activity.Form')"
							:active.sync="serviformAlertTwo"
							closable
							icon-pack="feather"
							close-icon="icon-x"
						>
							<span v-text="$t('Activity.AlertMissingForm')"></span>
						</vs-alert>
					</p>
				</vx-card>
			</div>
			<div class="vx-col md:w-2/7 w-full">
				<vx-card class="custom-height">
					<resource-assigned-list
						:resource_ids="activity_local.resource_id"
						:search="true"
						:pagination="true"
					></resource-assigned-list>
				</vx-card>
			</div>
			<div class="vx-col md:w-2/7 w-full">
				<vx-card class="custom-height">
					<assigned-group-list
						:navbarOptions="true"
						:groupListIds="activity_local.group_id"
						:columns="columns"
						:defaultColumns="defaultColumns"
					/>
				</vx-card>
			</div>
		</div>
		<!-- Save & Reset Button -->
		<div class="vx-row mt-4 flex items-center justify-end">
			<vs-button
				class="mr-2 g-btn--resourcePopup"
				type="border"
				color="danger"
				style="padding: 0.7rem 4.5rem"
				@click.prevent="$emit('changeActiveTabEmit', 0)"
				>{{ $t("Cancel") }}
			</vs-button>
			<vs-button
				id="button-create-loading"
				class="vs-con-loading__container ml-4 g-btn--resourcePopup"
				type="filled"
				color="success"
				:disabled="!this.validateForm"
				@click.prevent="saveChanges"
				>{{ $t("Save") + " " + $t("Activity.Activity") }}
			</vs-button>
		</div>
	</div>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import vSelect from "vue-select";
import moduleActivity from "@/store/activity/moduleActivity.js";
import moduleResource from "@/store/resource/moduleResource.js";
import moduleGroup from "@/store/group/moduleGroup.js";
import Activity from "@/models/Activity.js";
import Commons from "@/helpers/commons.js";
import ResourceAssignedList from "@/components/resource/user-list/ResourceAssignedList";
import AssignedGroupList from "@/components/group/AssignedGroupList";

export default {
	components: {
		AssignedGroupList,
		ResourceAssignedList,
		vSelect,
		flatPickr,
	},
	props: {
		data: {
			type: Activity,
			default: () => {
				new Activity({});
			},
		},
	},
	data() {
		return {
			activity_local: this.data,
			activeItem: 0,
			update: false,
			backgroundLoading: "primary",
			colorLoading: "#fff",
			selectedFormActivity: null,
			serviformAlert: false,
			serviformAlertTwo: false,
			hours: 0,
			minutes: 0,
			seconds: 0,
			activeDrPoints: false,
			onDemandAlert: false,
			columns: ["id", "name", "description", "address", "hour_init", "hour_end", "total_resource", "action"],
			defaultColumns: ["id", "name", "hour_init", "hour_end"],
		};
	},
	computed: {
		validateForm() {
			return (
				!this.errors.any() &&
				this.activity_local.name &&
				this.activity_local.description &&
				this.activity_local.service_time
			);
		},
		assignedResources() {
			return this.$store.state.moduleResource.resourcesActivity;
		},
		formActivityOptions() {
			return Commons.generateSelectOptios(
				this.$store.state.moduleActivity.formActivityOptions,
				"activity",
				"key"
			);
		},
		assignedResourcesTotal: {
			get() {
				this.totalResources = this.activity_local.count_resource;
				return this.totalResources;
			},
			set(val) {
				this.activity_local.count_resource = val;
			},
		},
		assignedGroups() {
			return this.$store.state.moduleGroup.groupsActivity;
		},
		assignedGroupsTotal: {
			get() {
				this.totalGroups = this.activity_local.count_group;
				return this.totalGroups;
			},
			set(val) {
				this.activity_local.count_group = val;
			},
		},
		scrollbarTag() {
			return this.$store.getters.scrollbarTag;
		},
	},
	methods: {
		saveChanges() {
			let resourcesIdChecked = this.assignedResources.map((r) => r.id);
			let groupsIdChecked = this.assignedGroups.map((r) => r.id);
			this.openLoadingContained();
			if (this.activity_local.id > 0) {
				this.activity_local.resource_id = [...new Set(resourcesIdChecked)];
				this.activity_local.group_id = [...new Set(groupsIdChecked)];
				this.updateActivity(this.activity_local);
			} else {
				this.activity_local.resource_id = resourcesIdChecked;
				this.activity_local.group_id = groupsIdChecked;
				this.createActivity(this.activity_local);
			}
		},
		openLoadingContained() {
			this.$vs.loading({
				background: this.backgroundLoading,
				color: this.colorLoading,
				container: "#button-create-loading",
				scale: 0.45,
			});
		},
		closeLoadingContained() {
			this.$vs.loading.close("#button-create-loading > .con-vs-loading");
		},
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		initValues() {
			if (this.activity_local.id) return;
			this.activity_local = new Activity({});
		},
		createActivity(obj) {
			delete obj.id;
			if (obj.active_form && this.selectedFormActivity === null) {
				this.serviformAlertTwo = true;
				setTimeout(() => {
					this.closeLoadingContained();
				}, 500);
				return;
			}
			if (this.activeDrPoints && this.activity_local.dr_points === null) {
				this.onDemandAlert = true;
				setTimeout(() => {
					this.closeLoadingContained();
				}, 500);
				return;
			}
			if (!this.activeDrPoints) this.activity_local.dr_points = null;
			this.$store
				.dispatch("moduleActivity/addActivityItem", obj)
				.then((res) => {
					this.closeLoadingContained();
					this.$vs.notify({
						color: "success",
						title: this.$t("TitleConfirmActivityCreate"),
						text: this.$t("TextConfirmActivityCreate"),
					});
					this.$emit("changeActiveTabEmit", 0);
				})
				.catch((err) => {
					this.closeLoadingContained();
					this.$vs.notify({
						color: "warning",
						title: this.$t("ErrorTitle"),
						text: this.$t("ErrorMessage"),
					});
					throw new Error(err);
				});
		},
		updateActivity(obj) {
			const activity = new Activity(obj);
			if (this.activeDrPoints && activity.dr_points === null) {
				this.onDemandAlert = true;
				setTimeout(() => {
					this.closeLoadingContained();
				}, 500);
				return;
			}
			if (!this.activeDrPoints) activity.dr_points = null;
			this.$store
				.dispatch("moduleActivity/updateActivityItem", activity)
				.then(() => {
					this.closeLoadingContained();
					this.$vs.notify({
						color: "success",
						title: this.$t("TitleConfirmActivityUpdate"),
						text: this.$t("TextConfirmActivityUpdate"),
					});
					this.$emit("changeActiveTabEmit", 0);
				})
				.catch((err) => {
					this.closeLoadingContained();
					this.$vs.notify({
						color: "warning",
						title: this.$t("ErrorTitle"),
						text: this.$t("ErrorMessage"),
					});
					throw new Error(err);
				});
		},
	},
	filters: {
		labelAsignTo(value) {
			if (value === "Seleccione") {
				return "Seleccione una opción en el campo Asignar a";
			} else {
				return value + "s";
			}
		},
	},
	watch: {
		selectedFormActivity(val) {
			this.activity_local.serviforms_form_id = val.value;
		},
		"activity_local.active_form"(val) {
			if (val) {
				this.$store
					.dispatch("moduleActivity/fetchFormsActivityList")
					.catch((err) => Commons.manageError.call(this, err));
			} else {
				this.selectedFormActivity = null;
			}
		},
		hours(val) {
			this.activity_local.service_time = `${val}:${this.minutes}:00`;
		},
		minutes(val) {
			this.activity_local.service_time = `${this.hours}:${val}:00`;
		},
	},
	created() {
		if (!moduleActivity.isRegistered) {
			this.$store.registerModule("moduleActivity", moduleActivity);
			moduleActivity.isRegistered = true;
		}
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}
		if (!moduleGroup.isRegistered) {
			this.$store.registerModule("moduleGroup", moduleGroup);
			moduleGroup.isRegistered = true;
		}
	},
	mounted() {
		if (this.activity_local.id <= 0) {
			this.initValues();
			this.$validator.reset();
		} else {
			this.openLoading();
			this.$store
				.dispatch("moduleActivity/fetchActivityById", this.activity_local.id)
				.then((res) => {
					this.activity_local = new Activity(res.data);
					this.update = true;
					if (this.activity_local.active_form)
						return this.$store.dispatch("moduleActivity/fetchFormsActivityList");
					return {data: []};
				})
				.then((res) => {
					if (res.data.length > 0) {
						const found = this.formActivityOptions.find(
							(act) => act.value === this.activity_local.serviforms_form_id
						);
						if (found) {
							this.selectedFormActivity = found;
						} else {
							this.selectedFormActivity = null;
							this.serviformAlert = true;
						}
					}
					const [hours, minutes, seconds] = this.activity_local.service_time.split(":");
					this.hours = parseInt(hours);
					this.minutes = parseInt(minutes);

					if (typeof this.activity_local.dr_points === "number") {
						setTimeout(() => {
							this.activeDrPoints = true;
						}, 100);
					}

					this.closeLoading();
				})
				.catch((err) => {
					this.closeLoading();
					this.$vs.notify({
						color: "warning",
						title: this.$t("MapModule.ErrorGenerateAppointment.Text"),
						text: this.$t("ErrorMessage"),
					});
					throw new Error(err);
				});
		}
	},

	beforeDestroy() {
		this.$store.dispatch("moduleResource/cleanResourceActivity");
		this.$store.dispatch("moduleGroup/cleanGroupActivity");
	},
};
</script>

<style lang="scss" scoped>
#activity-create-tab-info {
	height: 100%;
}

.custom-height {
	width: 100%;
	height: 550px;
}
</style>
